import React from "react";
import { ReactComponent as RemoveIcon } from "images/icons/remove.svg";
import {
  RestrictionModalFactory,
} from "src/storefront/types/restriction_modal_factories";
import { RestrictionType } from "../types/storefront";

export interface RestrictionModalProps {
  modalFactory: RestrictionModalFactory;
  hideModal: (updateHistory: boolean) => void;
  modalRef: React.MutableRefObject<HTMLDivElement | null>;
  updateRestrictionConfirmations: (newEntryValue: string) => void;
}

export const RestrictionModal = (props: RestrictionModalProps): React.JSX.Element => {
  const onConfirm = () => {
    props.updateRestrictionConfirmations(RestrictionType[props.modalFactory.type])
  }

  const closeModalViaCurtain = (e: React.MouseEvent) => {
    if (e.currentTarget != e.target) { return; }
    props.hideModal(true);
  };

  const closeModal = () => {
    props.hideModal(true)
  }

  return (
    <div className={"modal"} ref={props.modalRef} onClick={closeModalViaCurtain} data-testid={`restriction-modal-${props.modalFactory.type}`}>
      <div className="card">
        <div className="is-floating-button is-floating-right is-visible-above-desktop">
          <a className="button is-icon-only is-raised" aria-label="close" onClick={closeModal}>
            <RemoveIcon className="icon streamline-icon"/>
          </a>
        </div>

        {props.modalFactory.modal(onConfirm, closeModal)}
      </div>
    </div>
  )
}
